import { v4 as uuidv4 } from 'uuid';

const CLIENT_SESSION_KEY = 'issue-report-client-session-id';

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

// Guid.Empty is what the API falls back to on a bad value, so it is never a
// usable correlation id even when an engine hands us one.
export const isGuid = (value: string | null | undefined): boolean =>
  !!value && value !== EMPTY_GUID && GUID_REGEX.test(value);

// Per-tab fallback identifier, used when the current engine has no session key.
export const getClientSessionId = (): string => {
  try {
    const stored = sessionStorage.getItem(CLIENT_SESSION_KEY);

    if (isGuid(stored)) {
      return stored as string;
    }

    const generated = uuidv4();
    sessionStorage.setItem(CLIENT_SESSION_KEY, generated);
    return generated;
  } catch (e) {
    // Private mode / storage disabled: a per-call GUID still beats Guid.Empty.
    return uuidv4();
  }
};

// The API binds a non-GUID sessionId to Guid.Empty and still answers 200, which
// silently loses the correlation helpdesk needs, so never send anything else.
export const toSessionGuid = (value: string | null | undefined): string =>
  isGuid(value) ? (value as string) : getClientSessionId();
